
export enum Role {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  VIEWER = 'VIEWER'
}

export type Theme = 'light' | 'dark';

export interface User {
  id: string;
  email: string;
  name: string;
  role: Role;
  avatar?: string;
}

export interface AIEvent {
  id: string; 
  campaignName: string;
  category: string;
  url: string;
  priority: string;
  year: number;
  month: number;
  startDate: string; 
  endDate: string; 
  location: string;
  focusArea: string;
  information: string;
  addedAt: string;
  attendeeSize?: string;
  targetAudience?: string;
}

export interface Comment {
  id: string;
  eventId: string;
  authorEmail: string;
  text: string;
  timestamp: string;
}

export interface ReviewItem {
  type: 'NEW' | 'DUPLICATE' | 'UPDATE';
  event: AIEvent;
  existingEvent?: AIEvent;
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
}

export interface AppConfig {
  sheetId: string;
  tabName: string;
  googleClientId: string;
  discoveryKeywords: string[];
  supabaseUrl?: string;
  supabaseAnonKey?: string;
  supabaseTableName?: string;
  supabaseCommentsTableName?: string;
  theme?: Theme;
}